import React, { createContext, ReactNode, useContext, useMemo } from 'react';
import { ModalControl, useModalManagerState } from './useModalManager.state';

type Context = {
  showModal(render: (control: ModalControl) => ReactNode): void;
};

const initialContext: Context = {
  showModal: () => {},
};

const ModalManagerContext = createContext(initialContext);

export function ModalManagerProvider({ children }: { children?: ReactNode }) {
  const { add, modals } = useModalManagerState();

  const context = useMemo(
    () => ({
      showModal: add,
    }),
    [add],
  );

  return (
    <ModalManagerContext.Provider value={context}>
      {Object.values(modals).map((m) => (
        <React.Fragment key={m.id}>{m.render(m.control)}</React.Fragment>
      ))}
      {children}
    </ModalManagerContext.Provider>
  );
}

export function useModalManager() {
  return useContext(ModalManagerContext);
}
